document.addEventListener('DOMContentLoaded', function() {

    // // -----------------   Function to update the data-selected-var-id attribute based on the variant in the URL  --------------
    async function updateVariantId() {
        const pageURL = location.href.split('variant=')[1];
        let variantId = pageURL ? pageURL.split('&')[0] : null;
        if(variantId && variantId.includes('%')) {
            variantId = variantId.split('%')[0];
        }
        if (variantId) {
            const selectElement = document.querySelector('#productVariantOfferQty select');
            if (selectElement) {
                SelectedVarId = variantId;
                selectElement.setAttribute('data-selected-var-id', variantId);
                if(toCallUpdateQuantitySync) {
                    console.log('UpdateQuantitySync on var change   ----------- ',SelectedVarId);
                    UpdateQuantitySync();
                }
            }
        }
    }
    updateVariantId();
    let currentURL = location.href;
    const URLobserver = new MutationObserver(() => {
        if (currentURL !== location.href) {
            currentURL = location.href;
            updateVariantId(); 
        }
    });
    URLobserver.observe(document, { childList: true, subtree: true });
});


